
if (process.browser) {
	window.onNuxtReady((app) => {

		// Sync local data removes items from the basket if they are no longer on the account. THis will need rewriting
        app.syncLocalData();

        // Body background via CSP-safe class (styles from nonced style block)
        const backgroundClass = app.styleMeClass('vanilla', 'StoreFront', 'background');
        if (backgroundClass) {
            document.body.classList.add(backgroundClass);
        }

    });
}
